import { useSelector } from "react-redux";
import { CYLINDER_PREDICTION } from "../../../api/allApi_List";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import CylinderPredictionLayout from "../components/prediction/CylinderPredictionLayout";

const CylinderPredictionPage = () => {
  const { isLoaded } = useFetchData(CYLINDER_PREDICTION);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);

  return (
    <MainPageLayout headerConfig={{ title: "Cylinder Prediction" }}>
      {isLoaded && !error ? (
        <>
       <CylinderPredictionLayout />
        </>
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default CylinderPredictionPage;
